/**
 * The build's version string, for support calls ("what version are you on?").
 *
 * Comes from `package.json` via `REACT_APP_VERSION=$npm_package_version` in the
 * `start` and `build` scripts, so there is exactly one place to bump. Inlined at
 * build time by react-scripts, which is why it must be a `REACT_APP_*` variable
 * rather than a runtime lookup.
 *
 * Three routes were considered and rejected:
 *
 * - `import pkg from "../../package.json"` — CRA's ModuleScopePlugin hard-fails
 *   any import from outside `src/`.
 * - A `.env` file — `.gitignore` excludes `.env*`, and the Dockerfile does
 *   `COPY . .` from a clean CI checkout, so the file would be missing in the
 *   image and the version would inline as `undefined` *in production only*.
 * - A `prebuild` script — Yarn Berry does not run `pre`/`post` lifecycle
 *   scripts, so it would silently never fire.
 *
 * Falls back to "dev" so a bare `react-scripts start` still renders something
 * instead of the literal string "undefined".
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";
